// 使用 Vue 3 的导入方式
import { createRouter, createWebHistory } from 'vue-router'

// 路由配置保持不变
const constantRouterMap = [
  { path: '/', meta: { keepAlive: false }, component: () => import('@/views/home/home') },
]

// 创建路由实例（使用 Vue 3 的方式）
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})

export default router